import React from "react";

interface UnavailablePanelProps {
  reason?: string;
}

/** Graceful-degradation placeholder for a section whose data source is
 *  unavailable, without blocking the rest of the page (FR-014). */
const UnavailablePanel: React.FC<UnavailablePanelProps> = ({ reason }) => (
  <div
    className="flex flex-column align-items-center justify-content-center text-center"
    style={{ minHeight: "30vh" }}
    data-testid="unavailable-panel"
  >
    <i className="pi pi-exclamation-triangle text-4xl text-color-secondary mb-3" />
    <p className="text-color-secondary m-0">
      {reason || "This data is currently unavailable. Please try again later."}
    </p>
  </div>
);

export default UnavailablePanel;
